// extracted by mini-css-extract-plugin
export default {"label":"px9kfj mz-default-dark-font","extendedView":"UhHD_O","bags":"dTWWJW","tooltip":"nsFsOL","mobile":"XOazfq"};